import BaseTable from "../BaseTable";
import CurrencyModal from "@/Modals/CurrencyManagement/Currencies/Modal";
import { columns } from "./Columns";
import { currenciesApi } from "@/apis/apis";

export default function CurrenciesPage() {
  return (
    <BaseTable
      label="Currency"
      apiURL={currenciesApi}
      columns={columns()}
      ModalComponent={CurrencyModal}
      importData={null}
      enableExport={false}
      enableSortData={true}
    />
  );
}
